import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	icon?: React.ReactNode
	componentAfter?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, icon, componentAfter, ...props }, ref) => {
		let inputComponent = (
			<input
				type={type}
				className={cn(
					'shadow-xs dark:bg-input/30 h-10 w-full min-w-0 rounded-lg border border-input bg-transparent px-3 py-1 text-base outline-none transition-[color,box-shadow,border-color] duration-200 ease-out selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
					'focus-visible:ring-[3px] focus-visible:ring-ring/50',
					'font-medium text-foreground/70 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:font-light placeholder:text-foreground/30',
					'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
					'aria-[invalid]:border-input-invalid disabled:cursor-not-allowed disabled:opacity-50',
					className,
				)}
				ref={ref}
				{...props}
			/>
		)

		if (icon || componentAfter) {
			return (
				<div className="input-icon-wrapper">
					{icon && (
						<i style={{ lineHeight: 0 }} className="icon text-foreground/30">
							{icon}
						</i>
					)}
					{inputComponent}
					{componentAfter}
				</div>
			)
		}

		return inputComponent
	},
)
Input.displayName = 'Input'

export { Input }
